import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Elements/Modal/Modal";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import MainInput from "../Elements/MainInput/MainInput";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../Elements/SuccessMessage/SuccessMessage";
import WalletService from "../../services/WalletService";
import "./ProfileModals.css";

const VoucherModal = ({ isOpen, onClose, token, walletId, currency, onVoucherApplied }) => {
  const { t } = useTranslation();
  const [voucherCode, setVoucherCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [sending, setSending] = useState(false);

  const resetState = () => {
    setVoucherCode("");
    setError("");
    setSuccess("");
    setSending(false);
  };

  useEffect(() => {
    if (isOpen) resetState();
  }, [isOpen]);

  const parseVoucherApplyError = (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;

    if (status === 400 || status === 404) {
      return t("cart.invalidCode");
    }

    if (typeof detail === "string" && detail.trim()) {
      return detail;
    }

    return t("common.error");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!voucherCode.trim()) {
      setError(t("profile.enterVoucherCode"));
      return;
    }

    try {
      setSending(true);

      const response = await WalletService.applyVoucherCode({
        walletId,
        currency,
        promocode: voucherCode.trim(),
      });

      if (response.success && response.redirect_url) {
        window.location.href = response.redirect_url;
        return;
      }

      if (response.success) {
        setSuccess(t("profile.voucherApplied"));
        setTimeout(() => {
          onVoucherApplied?.();
          onClose();
        }, 1500);
        return;
      }

      setError(t("cart.invalidCode"));
    } catch (err) {
      setError(parseVoucherApplyError(err));
    } finally {
      setSending(false);
    }
  };

  const isButtonDisabled = sending || !voucherCode.trim();

  return (
    <Modal
      isOpen={isOpen}
      onClose={sending ? () => {} : onClose}
      title={t("profile.gotVoucherCode")}
      actions={
        <>
          <SecondButton onClick={onClose} disabled={sending}>
            {t("common.cancel")}
          </SecondButton>
          <MainButton onClick={handleSubmit} disabled={isButtonDisabled}>
            {sending ? t("profile.applying") : t("cart.apply")}
          </MainButton>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="profile-modal-form">
        <label>
          {t("profile.voucherCode")}
          <MainInput
            value={voucherCode}
            onChange={(e) => {
              setVoucherCode(e.target.value);
              setError("");
            }}
            disabled={sending}
            placeholder={t("profile.enterVoucherCode")}
          />
        </label>

        {error && (
          <div className="profile-transfer-error-wrapper">
            <ErrorMessage message={error} onClose={() => setError("")} />
          </div>
        )}

        {success && (
          <div className="profile-transfer-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess("")} />
          </div>
        )}
      </form>
    </Modal>
  );
};

export default VoucherModal;
